import { Box, Layout, Cell } from '@wix/design-system';
import React, { useEffect } from 'react';
import s from '../styles/page.scss';
import { useHasMetasiteError } from '../store/appStore';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { DsBuilderMethod } from '../types';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { Checkout as CheckoutRoot } from '../features/checkout/Checkout';

type CheckoutPageProps = {};

export const Checkout: React.FC<CheckoutPageProps> = () => {
  const metasiteError = useHasMetasiteError();

  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.CHECKOUT]);
  }, []);

  if (metasiteError) {
    return <GeneralError />;
  }

  return (
    <>
      <Layout gap="32px">
        <Cell span={12}>
          <Box className={s.sectorBoxWrapper}>
            <CheckoutRoot />
          </Box>
        </Cell>
      </Layout>
    </>
  );
};
